import { logging } from '@js-sdk/debug-tools';
import { Errors } from '../enums/errors';
import { StorageError } from '../error/storage';
const debugLogger = logging.forTag('playback.storage_resolve');
const MANIFEST_URL = 'https://seektables.scdn.co/seektable';
export class StorageResolve {
    constructor(transport) {
        this._transport = transport;
    }
    _parseResponse(fileId, response) {
        let error;
        if (response.status !== 200) {
            error = new StorageError(Errors.STORAGE_FAILED_WITH_STATUS, `Storage Resolve responded with ${response.status}`);
            error.status = response.status;
            error.fileId = fileId;
            return Promise.reject(error);
        }
        const body = response.body;
        if (!body || !body.cdnurl || !body.cdnurl.length) {
            error = new StorageError(Errors.STORAGE_RETURNED_NO_TRACKS, `Storage Resolve returned no tracks for fileId ${fileId}`);
            error.fileId = fileId;
            return Promise.reject(error);
        }
        const result = {
            uri: body.cdnurl[0],
            uris: body.cdnurl,
            protection: 'cenc',
        };
        return Promise.resolve(result);
    }
    getCDNURL(fileId) {
        debugLogger.info('Requesting CDN URL for ', fileId);
        const path = '@webgate/storage-resolve/files/audio/interactive';
        const params = 'version=10000000&product=9&platform=39&alt=json';
        const endpoint = `${path}/${fileId}?${params}`;
        return this._transport
            .request(endpoint, {
            responseType: 'json',
            retry: {
                condition: (response, _StatusFamily) => response.getStatusFamily() !== _StatusFamily.SUCCESS,
            },
        })
            .then(this._parseResponse.bind(this, fileId));
    }
    getManifest(fileId) {
        const url = `${MANIFEST_URL}/${fileId}.json`;
        debugLogger.info('Requesting JSON manifest for ', fileId);
        return this._transport
            .request(url, {
            responseType: 'json',
            retry: {
                condition: (response, _StatusFamily) => response.getStatusFamily() !== _StatusFamily.SUCCESS,
            },
        })
            .then((response) => {
            let error;
            if (response.status !== 200) {
                error = new StorageError(Errors.STORAGE_TRACK_MANIFEST_FAILED, `Track manifest request failed with status code ${response.status}`);
                error.debug.file_id = fileId;
                error.status = response.status;
                return Promise.reject(error);
            }
            if (!response.body) {
                error = new StorageError(Errors.STORAGE_TRACK_MANIFEST_EMPTY, 'Received empty manifest.');
                error.debug.file_id = fileId;
                error.status = response.status;
                return Promise.reject(error);
            }
            return response.body;
        });
    }
}
//# sourceMappingURL=storage_resolve.js.map